import uniqBy from "lodash/uniqBy"
import sortBy from "lodash/sortBy"
import suppressFaculty from "config/suppressFaculty";
import { emmaGet } from "services/emma/server"

export async function getRoomsInSessionTypes(sessionTypeCSV, emmaMeetingId) {
    const filterSessionTypeIdsParamString = sessionTypeCSV
        .split(",")
        .map(sessionTypeId => {
            return `&filter_session_type_id[]=${sessionTypeId.trim()}`
        })
        .join("")

    const data = await emmaGet(
        `/conferences/${emmaMeetingId}/events/?fresh=true&depth=2${filterSessionTypeIdsParamString}`,
    )

    // extract unique venues from events
    const uniqueRooms = uniqBy(
        data.data.events.data.map(event => event.venue),
        item => item.id,
    )

    return sortBy(uniqueRooms, room => room.name.toLowerCase())
}

export function filterSuppressedFaculty(meetingId, faculty, key = "faculty_id") {
    const suppressedFacultyIds = [...suppressFaculty.all, ...(suppressFaculty[meetingId] || [])]
    return faculty.filter(fac => !suppressedFacultyIds.includes(fac[key]))
}

export function findVenueRecursive(venueId, venues) {
    for (let i = 0; i < venues.length; i++) {
        if (venues[i].id == venueId) {
            return venues[i]
        }
        if (venues[i].children) {
            const result = findVenueRecursive(venueId, venues[i].children)
            if (result) {
                return result
            }
        }
    }
    return null
}